import loadable from '@loadable/component';

export const IntegrateAtsLinksLoadable = loadable(
  () => import('./IntegrateAtsLinks'),
  { resolveComponent: (module) => module.IntegrateAts },
);
